import React, { useState } from "react";
import Button from "shared/Button";
import { colors } from "styles/colors";
import Input from "shared/Input";
import Modal from "shared/Modal";
import { EmailModalTitle, EmailButtonsWrap, EmailsWrapper } from "./styled";

const EmailModal = ({ onCancel = () => {}, onConfirm = () => {} }) => {
  const [emailsInput, setEmailsInput] = useState("");

  return (
    <Modal type="email">
      <EmailModalTitle>Send via Email</EmailModalTitle>
      <EmailsWrapper>
        <Input
          error={false}
          errorMessage={false}
          value={emailsInput}
          onKeyPress={(e) => {
            if (e.charCode === 13) {
              onConfirm(emailsInput);
            }
          }}
          onChange={(e) => setEmailsInput(e.target.value)}
          placeholder="Enter email..."
        />
      </EmailsWrapper>
      <EmailButtonsWrap>
        <Button onClick={onCancel} color={colors.WHITE} textColor={colors.GREY_DARK} stylType="outline" text="Cancel" />
        <Button color={colors.RED} stylType="primary" onClick={() => onConfirm(emailsInput)} text="Send" />
      </EmailButtonsWrap>
    </Modal>
  );
};

export default EmailModal;
